import { Box } from '@material-ui/core'
import React from 'react'
import { FullFormatOptions } from '../../../../util/formatters'
import { CalibrationLineChart } from './CalibrationLineChart'
import { CustomSeries } from '../chart-util'

type Props = {
  energySystemData: CustomSeries[]
  measuredData: CustomSeries
  xFormatter: (value: number) => string
  yFormatter: (value: number, options?: FullFormatOptions) => string
  axisBottomLegend?: string
  axisLeftLegend?: string
  showPoints?: boolean
  legendItemWidth?: number
}

export function LineGraphContent({
  energySystemData,
  measuredData,
  xFormatter,
  yFormatter,
  axisBottomLegend,
  axisLeftLegend,
  showPoints = false,
  legendItemWidth,
}: Props): React.ReactElement {
  const chartData =
    measuredData.data.length > 0
      ? [measuredData, ...energySystemData]
      : energySystemData

  // const xAxisValueFormatter = (index: number) => index.toString()

  return (
    <Box width="100%" height={540} borderRadius={6}>
      {chartData.length > 0 && (
        <CalibrationLineChart
          data={chartData}
          xFormatter={xFormatter}
          yFormatter={yFormatter}
          // xAxisFormatter={xAxisValueFormatter}
          axisBottomLegend={axisBottomLegend}
          axisLeftLegend={axisLeftLegend}
          showPoints={showPoints}
          legendItemWidth={legendItemWidth}
        />
      )}
    </Box>
  )
}
